/* MCE Native Calculator Suite — staging build 2026-08-04. Replaces Calconic.
   Formulas LOCKED (catalog-architecture plan):
   - dims mode:  tilesW = ceil(L/2), tilesL = ceil(W/2), need = tilesW * tilesL
   - sqft mode:  need = ceil(sqft/4); clip grid assumes near-square room (estimate)
   - recommended = ceil(need * (1 + overage)), overage 5/10/15% default 15
   - nails: boxes = ceil(rec * 12 / 450)   (6" spacing verified from install guide 8/4)
   - clips: (tilesW + 1) * (tilesL + 1) from ROOM GRID (not overage); packs = ceil(/50)
   - MOQ: powder-coated colors, rec < 20 → warn */
(function () {
  'use strict';

  var money = function (n) { return '$' + n.toFixed(2); };
  var NAIL_DEFAULT = { white: 'White', copper: 'Copper', steel: 'Stainless', warm: 'Copper', dark: 'Bright Steel', raw: 'Bright Steel' };

  function readJSON(el, sel) {
    var node = el.querySelector(sel);
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  function computeTiles(mode, L, W, sf, ov) {
    var tW, tL, need, approx = false;
    if (mode === 'dims') {
      tW = Math.ceil(L / 2); tL = Math.ceil(W / 2); need = tW * tL;
    } else {
      need = Math.ceil(sf / 4);
      var side = Math.ceil(Math.sqrt(need || 0));
      tW = side; tL = side ? Math.ceil(need / side) : 0;
      approx = true;
    }
    return { tW: tW, tL: tL, need: need, rec: Math.ceil(need * (1 + ov)), approx: approx };
  }
  function nailBoxes(rec) { return Math.ceil(rec * 12 / 450); }
  function clipCount(tW, tL) { return (tW + 1) * (tL + 1); }

  /* ------- shared dims/sqft input group ------- */
  function bindDimsInputs(el, onChange) {
    var state = { mode: 'dims' };
    var dimsBtn = el.querySelector('[data-m="dims"]');
    var sqftBtn = el.querySelector('[data-m="sqft"]');
    function setMode(m) {
      state.mode = m;
      var dims = m === 'dims';
      el.querySelectorAll('[data-dims-only]').forEach(function (n) { n.style.display = dims ? '' : 'none'; });
      el.querySelectorAll('[data-sqft-only]').forEach(function (n) { n.style.display = dims ? 'none' : ''; });
      if (dimsBtn) { dimsBtn.classList.toggle('is-on', dims); sqftBtn.classList.toggle('is-on', !dims); }
      onChange();
    }
    if (dimsBtn) {
      dimsBtn.addEventListener('click', function () { setMode('dims'); });
      sqftBtn.addEventListener('click', function () { setMode('sqft'); });
    }
    el.querySelectorAll('input, select').forEach(function (n) {
      n.addEventListener('input', onChange);
      n.addEventListener('change', onChange);
    });
    state.read = function () {
      return computeTiles(
        state.mode,
        +((el.querySelector('[data-in="l"]') || {}).value) || 0,
        +((el.querySelector('[data-in="w"]') || {}).value) || 0,
        +((el.querySelector('[data-in="sf"]') || {}).value) || 0,
        +((el.querySelector('[data-in="ov"]') || {}).value || 0.15)
      );
    };
    return state;
  }

  function addToCart(items, btn) {
    btn.classList.add('mce-calc__cta--busy');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      window.location.href = '/cart';
    }).catch(function () {
      btn.classList.remove('mce-calc__cta--busy');
      btn.textContent = 'SOMETHING WENT WRONG — TRY AGAIN';
    });
  }

  /* ------- mode: estimator (tile PDP — installation-aware, whole-project cart) ------- */
  function initEstimator(el) {
    var variants = readJSON(el, '.mce-calc-variants') || [];
    var hw = readJSON(el, '.mce-calc-hardware') || {};
    var sectionEl = el.closest('.shopify-section');
    var finish = null;
    if (sectionEl) {
      var fd = sectionEl.querySelector('.mce-finish-data');
      if (fd) { try { finish = JSON.parse(fd.textContent).colors; } catch (e) {} }
    }
    var byName = {};
    (finish || []).forEach(function (c) { byName[c.name] = c; });

    var out = el.querySelector('.mce-calc__out');
    var warn = el.querySelector('.mce-calc__warn');
    var cta = el.querySelector('.mce-calc__cta');
    var nailRow = el.querySelector('[data-nail-row]');
    var nailSel = el.querySelector('[data-in="nailcolor"]');
    var optout = el.querySelector('[data-in="hw"]');
    var lastAutoNail = null;

    function selected(optName) {
      if (!sectionEl) return null;
      var sel = sectionEl.querySelector('.option-selector[data-option="' + optName + '"] .js-option:checked');
      return sel ? sel.value : null;
    }
    function currentVariant(install, color) {
      for (var i = 0; i < variants.length; i += 1) {
        var v = variants[i];
        if (v.install === install && v.color === color) return v;
      }
      return null;
    }

    var dims;
    function compute() {
      var t = dims.read();
      var install = selected('Installation') || 'Nail-Up';
      var color = selected('Color') || 'Unfinished';
      var isNail = install !== 'Drop-In';
      if (nailRow) nailRow.style.display = isNail ? '' : 'none';

      // smart nail default follows the tile color family (until next color change)
      var fam = (byName[color] || {}).family || 'raw';
      var autoNail = NAIL_DEFAULT[fam] || 'Bright Steel';
      if (nailSel && autoNail !== lastAutoNail) { nailSel.value = autoNail; lastAutoNail = autoNail; }

      if (!t.need) {
        out.innerHTML = '<span style="color:#98a0a8">Enter your ceiling ' + (dims.mode === 'dims' ? 'dimensions' : 'square footage') + '.</span>';
        warn.classList.remove('is-on');
        cta.disabled = true; cta.textContent = 'ADD PROJECT TO CART';
        return;
      }

      var variant = currentVariant(install, color);
      var tilePrice = variant ? variant.price / 100 : null;
      var lines = 'Tiles needed: <b>' + t.need + '</b> &nbsp;·&nbsp; Recommended with overage: <b>' + t.rec + ' tiles</b>';
      if (tilePrice !== null) lines += '<br>Tiles in <b>' + color + '</b> (' + install + '): <b>' + money(t.rec * tilePrice) + '</b>';

      var hwItems = [], hwLabel = '';
      if (isNail && hw.nails) {
        var boxes = nailBoxes(t.rec);
        var chosen = nailSel ? nailSel.value : 'Bright Steel';
        var nv = hw.nails[chosen];
        if (nv) {
          lines += ' &nbsp;·&nbsp; Cone head nails (' + chosen + '): <b>' + boxes + ' box' + (boxes === 1 ? '' : 'es') + '</b> = ' + money(boxes * nv.price / 100) + ' <span style="color:#98a0a8">(~12/tile, ~450/box)</span>';
          hwItems = [{ id: nv.id, quantity: boxes }];
          hwLabel = boxes + ' box' + (boxes === 1 ? '' : 'es') + ' nails';
        }
      } else if (!isNail && hw.clips) {
        var clips = clipCount(t.tW, t.tL);
        var packs = Math.ceil(clips / 50);
        lines += ' &nbsp;·&nbsp; Hold-down clips: <b>' + (t.approx ? '≈' : '') + clips + '</b> → <b>' + packs + ' pack' + (packs === 1 ? '' : 's') + '</b> = ' + money(packs * hw.clips.price / 100) +
          ' <span style="color:#98a0a8">(one per grid intersection, 50/pack' + (t.approx ? ' — estimated; enter room dimensions for an exact count' : '') + ')</span>';
        hwItems = [{ id: hw.clips.id, quantity: packs }];
        hwLabel = packs + ' clip pack' + (packs === 1 ? '' : 's');
      }
      out.innerHTML = lines;

      var tier = (byName[color] || {}).tier;
      var isPowder = tier === 'powder';
      warn.classList.toggle('is-on', isPowder && t.rec < 20);
      if (isPowder && t.rec < 20) warn.innerHTML = '⚠ ' + t.rec + ' tiles is below the <b>20-tile minimum</b> for powder-coated colors — round up to 20 or choose Unfinished/Clear.';

      var includeHw = optout ? optout.checked : true;
      cta.disabled = !variant;
      var items = variant ? [{ id: variant.id, quantity: t.rec }] : [];
      if (includeHw && hwItems.length) items = items.concat(hwItems);
      cta.textContent = includeHw && hwLabel
        ? 'ADD PROJECT TO CART — ' + t.rec + ' tiles + ' + hwLabel
        : 'ADD TILES TO CART — ' + t.rec + ' tiles';
      cta.dataset.mceItems = JSON.stringify(items);
    }

    dims = bindDimsInputs(el, function () { compute(); });
    cta.addEventListener('click', function () {
      var items = JSON.parse(cta.dataset.mceItems || '[]');
      if (items.length) addToCart(items, cta);
    });
    document.addEventListener('on:variant:change', function () { setTimeout(compute, 20); });
    compute();
  }

  /* ------- mode: tiles (resources page — standalone, crawlable) ------- */
  function initTiles(el) {
    var out = el.querySelector('.mce-calc__out');
    var dims;
    function compute() {
      var t = dims.read();
      if (!t.need) { out.innerHTML = '<span style="color:#98a0a8">Enter your ceiling size above.</span>'; return; }
      var boxes = nailBoxes(t.rec);
      var clips = clipCount(t.tW, t.tL);
      var packs = Math.ceil(clips / 50);
      out.innerHTML =
        'Tiles needed: <b>' + t.need + '</b> &nbsp;·&nbsp; Recommended with overage: <b>' + t.rec + ' tiles</b><br>' +
        'Nail-up install: <b>' + boxes + ' box' + (boxes === 1 ? '' : 'es') + '</b> of cone head nails <span style="color:#98a0a8">(~12/tile, ~450/box)</span><br>' +
        'Drop-in install: <b>' + (t.approx ? '≈' : '') + clips + ' hold-down clips</b> → <b>' + packs + ' pack' + (packs === 1 ? '' : 's') + '</b>' +
        (t.approx ? ' <span style="color:#98a0a8">(estimated — enter room dimensions for an exact count)</span>' : '');
    }
    dims = bindDimsInputs(el, compute);
    compute();
  }

  /* ------- mode: nails (nails PDP + resources) ------- */
  function initNails(el) {
    var out = el.querySelector('.mce-calc__out');
    var cta = el.querySelector('.mce-calc__cta');
    function compute() {
      var tiles = +((el.querySelector('[data-in="tiles"]') || {}).value) || 0;
      if (!tiles) { out.innerHTML = '<span style="color:#98a0a8">Enter how many tiles you’re installing.</span>'; if (cta) cta.disabled = true; return; }
      var boxes = nailBoxes(tiles);
      out.innerHTML = 'For <b>' + tiles + ' tiles</b> you’ll need <b>' + boxes + ' box' + (boxes === 1 ? '' : 'es') + '</b> <span style="color:#98a0a8">(~12 nails/tile at 6" spacing, ~450/box)</span>';
      if (cta) { cta.disabled = false; cta.textContent = 'SET QUANTITY TO ' + boxes; cta.dataset.mceQty = boxes; }
    }
    el.querySelectorAll('input').forEach(function (n) { n.addEventListener('input', compute); });
    if (cta) {
      cta.addEventListener('click', function () {
        var qty = +cta.dataset.mceQty || 1;
        var form = document.querySelector('.js-product-form');
        var qtyInput = form ? form.querySelector('input[name="quantity"]') : document.querySelector('input[name="quantity"]');
        if (qtyInput) {
          qtyInput.value = qty;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
          qtyInput.closest('.shopify-section, body').scrollIntoView({ behavior: 'smooth' });
        }
      });
    }
    compute();
  }

  /* ------- mode: clips (clips PDP) ------- */
  function initClips(el) {
    var out = el.querySelector('.mce-calc__out');
    var cta = el.querySelector('.mce-calc__cta');
    var dims;
    function compute() {
      var t = dims.read();
      if (!t.need) { out.innerHTML = '<span style="color:#98a0a8">Enter your ceiling size above.</span>'; if (cta) cta.disabled = true; return; }
      var clips = clipCount(t.tW, t.tL);
      var packs = Math.ceil(clips / 50);
      out.innerHTML = 'Grid: <b>' + t.tW + ' × ' + t.tL + ' tiles</b> &nbsp;·&nbsp; Clips: <b>' + (t.approx ? '≈' : '') + clips + '</b> <span style="color:#98a0a8">(one per T-rail intersection)</span><br>' +
        'You’ll need <b>' + packs + ' pack' + (packs === 1 ? '' : 's') + '</b> of 50' +
        (t.approx ? ' <span style="color:#98a0a8">(estimated — enter room dimensions for an exact count)</span>' : '');
      if (cta) { cta.disabled = false; cta.textContent = 'SET QUANTITY TO ' + packs; cta.dataset.mceQty = packs; }
    }
    dims = bindDimsInputs(el, compute);
    if (cta) {
      cta.addEventListener('click', function () {
        var qty = +cta.dataset.mceQty || 1;
        var form = document.querySelector('.js-product-form');
        var qtyInput = form ? form.querySelector('input[name="quantity"]') : document.querySelector('input[name="quantity"]');
        if (qtyInput) {
          qtyInput.value = qty;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
    compute();
  }

  function init() {
    document.querySelectorAll('.mce-calc:not([data-mce-init])').forEach(function (el) {
      el.dataset.mceInit = '1';
      try {
        var mode = el.dataset.mode;
        if (mode === 'estimator') initEstimator(el);
        else if (mode === 'tiles') initTiles(el);
        else if (mode === 'nails') initNails(el);
        else if (mode === 'clips') initClips(el);
      } catch (e) { /* fail quiet — page still works without the calculator */ }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
